import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SolrService} from "../../services/solr.service";
import {FiltersService} from "../../services/filters.service";

@Component({
  selector: 'app-regulations',
  templateUrl: './regulations.component.html',
  styleUrls: ['./regulations.component.scss']
})
export class RegulationsComponent implements OnInit {

  defaults: any;
  filters: any;
  constructor(private solrService: SolrService,
              private filtersService: FiltersService) {
    this.filtersService.filters.subscribe((filters: any) => {
      this.filters = filters;
    });
    this.solrService.defaults.subscribe((defaults:any) => {
      this.defaults = defaults;
    })
  }

  ngOnInit(): void {
  }
  toggle(id:number, checked:boolean){
    let i = this.filters.regulations.indexOf(id);
    if(checked && i === -1){
      this.filters.regulations.push(id);
    }
    else if(!checked && i !== -1){
      this.filters.regulations.splice(i, 1);
    }
    this.filtersService.setFilters(this.filters);
  }
  opened(){
    this.filters.expanded.regulations = true;
    this.filtersService.setFilters(this.filters);
  }
  closed(){
    this.filters.expanded.regulations = false;
    this.filtersService.setFilters(this.filters);
  }

}
